import {InitPage} from "../../index";
import {ElcProductionReporting} from "./reporting";

declare const saveEmployeeLoggedTimes;

declare var App: any;
declare var storeLocation: string;
declare var productionId: number;

export class ElCProductionLiveUpdateCard {
    elcProductionUpdateChannel: any;

    constructor() {
        let n = new ElcProductionReporting();

        this.elcProductionUpdateChannel = App.cable.subscriptions.create(
            {
              channel: "ELC::ProductionsChannel",
              tenant: storeLocation,
              production_id: productionId
            },
            {
              connected() { console.log("Production Card Update Channel Connected") },
              disconnected() { /* Called when the subscription has been terminated by the server */ },
              received: (data: any) => this.updateStats(data, n)
            }
        );
    }

    updateStats(data, n) {
        console.log(data);
        this.convertTime(data.running_time);
        $('#total_quantity').text(data.total_quantity);
        $("#modal_current_reported_qty").text(data.current_reported_qty);   // in report production modal

        $("#expected_qty_since_last_report").text(data.expected_qty_since_last_report);
        $("#qty_under_or_over").text(data.qty_under_or_over);
        $("#current_percentage").text(data.current_percentage);
        if(data.update_data)
        {
            $("#current_reported_qty").text(data.current_reported_qty);   // in card page
            $("#extra_labour").text(data.extra_labour);
            $("#current_employees").text(data.current_employees);
            $("#extra_labour_cost").text(data.extra_labour_cost);
            if(data.variance_cost_percentage && data.variance_cost_percentage >= 95)
            {
                $("#extra_labour_cost").removeClass('text-danger');
                $("#extra_labour_cost").addClass('text-success');
            }
            else
            {
                $("#extra_labour_cost").removeClass('text-success');
                $("#extra_labour_cost").addClass('text-danger');
            }
        }
       
        // $("#live_expected_qty").text(data.live_expected_qty);
        // $("#current_upm").text(data.current_upm);
        // $("#net_gain_loss").text(data.net_gain_loss);
        //if(data.net_gain_loss > 0)
        //{
        //    $("#net_gain_loss").removeClass('text-danger');
        //    $("#net_gain_loss").addClass('text-success');
        //}
        //else if (data.net_gain_loss < 0)
        //{
        //    $("#net_gain_loss").removeClass('text-success');
        //    $("#net_gain_loss").addClass('text-danger');
        //}
        //else
        //{
        //    $("#net_gain_loss").removeClass('text-success');
        //    $("#net_gain_loss").removeClass('text-danger');
        //}
        // $("#net_gain_loss_percentage").text(data.net_gain_loss_percentage);
        // $("#productivity_gain_loss").text(data.productivity_gain_loss); 
        //if(data.productivity_gain_loss > 0)
        //{
        //    $("#productivity_gain_loss").removeClass('text-danger');
        //    $("#productivity_gain_loss").addClass('text-success');
        //}
        //else if(data.productivity_gain_loss < 0)
        //{
        //    $("#productivity_gain_loss").removeClass('text-success');
        //    $("#productivity_gain_loss").addClass('text-danger');
        //}
        //else
        //{
        //    $("#productivity_gain_loss").removeClass('text-success');
        //    $("#productivity_gain_loss").removeClass('text-danger');
        //}
        //$("#productivity_percentage").text(data.productivity_percentage);
        $("#live_employee_head_count").text(data.live_employee_head_count);
        $("#time_passed_since_last_report").text(data.time_passed_since_last_report);
        // $("#qty_under_over_produced").text(data.qty_under_over_produced);
        // $("#current_percentage_since_last_report").text(data.current_percentage_since_last_report);
        n.report_production();
    }

    convertTime(timeInSec) {
        if(timeInSec > 0)
        {
            let hour = Math.floor(timeInSec / 3600);
            let minute = Math.floor((timeInSec - hour * 3600) / 60);
            let seconds = timeInSec - (hour * 3600 + minute * 60);
            $("#timer").html(String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0") + ":" + String(seconds).padStart(2, "0") );
        }
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("cards index", () => {
            const c = new ElCProductionLiveUpdateCard();
        });
    });
}
